export const ClassSpecialTypes = {
  REGULAR: 'Regular course',
  DOCUMENTARY: 'Documentary',
  UNORDERED: 'Unordered',
} as const

export type ClassSpecialType =
  (typeof ClassSpecialTypes)[keyof typeof ClassSpecialTypes]

export const getClassSpecialType = (course: { slug?: string }) => {
  if (
    course.slug === 'tehachapi' ||
    course.slug === 'the-cowboy-and-the-queen' ||
    course.slug === 'diane-warren-relentless' ||
    course.slug === 'copa-71' ||
    course.slug === 'happy-clothes'
  ) {
    return ClassSpecialTypes.DOCUMENTARY
  }

  if (course.slug === 'skin-health') {
    return ClassSpecialTypes.UNORDERED
  }

  return ClassSpecialTypes.REGULAR
}
